import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/live-ar-training"
    exact
    path="/business/products/live-ar-training"
    component={AsyncPage}
  />,
];
